const generatedStrings = new Set();

export function Randomnumber(length) {
  if (length < 2) throw new Error("Length must be at least 2");

  const digits = '0123456789';
  const nonZeroDigits = '123456789';
  let result;

  do {
    result = '';
    // First digit (non-zero)
    result += nonZeroDigits.charAt(Math.floor(Math.random() * nonZeroDigits.length));

    // Middle digits (any digit)
    for (let i = 1; i < length - 1; i++) {
      result += digits.charAt(Math.floor(Math.random() * digits.length));
    }

    // Last digit (non-zero)
    result += nonZeroDigits.charAt(Math.floor(Math.random() * nonZeroDigits.length));

  } while (generatedStrings.has(result));

  generatedStrings.add(result);
  return result;
}
